<template>
  <div class="c-list-box">
    <ul class="c-list-nav">
      <li class="c-list-title">到账合并</li>
    </ul>
    <ul class="c-list-search">
      <el-config-provider
        :value-on-clear="null"
        :empty-values="[undefined, null]"
      >
        <el-space wrap style="flex: 1">
          <el-select
            v-model="state.params.customer_id"
            placeholder="认领客户"
            style="width: 300px"
          >
            <el-option
              v-for="item in state.customer_data"
              :key="item"
              :value="item.id"
              :label="item.name"
            ></el-option>
            <template #footer>
              <el-button size="small" @click="onLoadCustomer()">
                刷新
              </el-button>
            </template>
          </el-select>
          <el-select
            v-model="state.params.status"
            style="width: 140px"
            placeholder="状态"
          >
            <el-option label="待审核" :value="0"></el-option>
            <el-option label="审核通过" :value="1"></el-option>
            <el-option label="审核不通过" :value="2"></el-option>
          </el-select>
          <el-select
            v-model="state.params.is_back"
            style="width: 120px"
            placeholder="是否撤回"
          >
            <el-option label="未撤回" :value="0"></el-option>
            <el-option label="已撤回" :value="1"></el-option>
          </el-select>
          <el-date-picker
            v-model="state.dates"
            type="daterange"
            range-separator="至"
            start-placeholder="申请日期"
            end-placeholder="申请日期"
            value-format="YYYY-MM-DD"
            @change="
              (value) => {
                if (value)
                  state.params.create_time = value[0] + ' - ' + value[1];
              }
            "
            style="width: 260px"
            @clear="
              delete state.dates;
              delete state.params.create_time;
            "
          />
          <el-dropdown split-button @click="onLoad" type="primary">
            查询
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
                  重置
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </el-space>
      </el-config-provider>
    </ul>
    <ul class="c-list-table">
      <el-table
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
      >
        <el-table-column
          fixed
          label="序号"
          width="70"
          type="index"
          :index="
            (index) => (state.params.page - 1) * state.params.limit + index + 1
          "
          align="center"
        />
        <el-table-column label="状态" sortable="status" width="120">
          <template #default="{ row }">
            <text v-if="row.is_back" style="color: #f00">已撤回</text>
            <c_status
              v-else
              arr-name="bankreceivedmerge_status"
              :value="row.status"
            />
          </template>
        </el-table-column>
        <el-table-column
          label="金额"
          prop="received_amount"
          :formatter="$tab_PriceFormat"
          min-width="140"
        />
        <el-table-column
          label="实际到账金额/手续费"
          :formatter="
            (row) =>
              $tab_GroupFormat(
                $priceFormat(row.real_received_amount),
                $priceFormat(row.service_fee)
              )
          "
          min-width="160"
        />
        <el-table-column label="到款记录数量" min-width="140">
          <template #default="{ row }">
            <text>{{ row.bank_received_ids.split(",")?.length }}</text>
          </template>
        </el-table-column>
        <el-table-column
          label="主体到款记录Id"
          prop="bank_received_id"
          sortable="bank_received_id"
          width="160"
          :formatter="$tab_TextFormat"
        />
        <el-table-column
          label="匹配客户"
          prop="customer_name"
          width="200"
          :formatter="$tab_TextFormat"
        />
        <el-table-column
          label="申请人/申请时间"
          sortable="create_time"
          :formatter="
            (row) =>
              $tab_GroupFormat(
                row.add_admin_name + '/' + row.add_department_name,
                row.create_time || ''
              )
          "
          min-width="180"
        />
        <el-table-column
          label="是否撤回"
          prop="customer_name"
          width="200"
          :formatter="$tab_TextFormat"
        >
          <template #default="{ row }">
            <text v-if="row.is_back" style="color: #f00">是</text>
            <text v-else>否</text>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="260"
          align="center"
          fixed="right"
          className="tabBtn"
        >
          <template #default="{ row }">
            <el-button
              type="primary"
              link
              icon="Select"
              @click="
                state.selectId = row.id;
                state.showDetail = true;
              "
              v-if="row.status == 0 && !row.is_back && $judge_auth('733')"
            >
              审核
            </el-button>
            <el-button
              type="primary"
              link
              icon="Search"
              @click="
                state.selectId = row.id;
                state.showDetail = true;
              "
              v-else
            >
              查看
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </ul>
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="state.showDetail"
        title="到账合并记录详情"
        @close="state.showDetail = false"
      >
        <c_BankReceivedMergeDetail
          @close="state.showDetail = false"
          @confirm="
            state.showDetail = false;
            onLoad();
          "
          :id="state.selectId"
        ></c_BankReceivedMergeDetail>
      </c_popup>
    </transition>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import { bankreceivedmerge_list } from "@/http/bankreceivedmerge";
import { data_customer_select } from "@/http/data";

class InitFormData {
  params = {
    limit: 20,
    page: 1,
    sort_field: "create_time",
    sort_value: "desc",
  };
}
export default {
  setup() {
    const state = reactive(new InitFormData());
    onMounted(() => {
      onLoadCustomer();
      onLoad();
    });

    const onLoad = () => {
      delete state.tableData;

      if (state.bank_account_ids?.length > 0)
        state.params.bank_account_id = state.bank_account_ids.join(",");

      bankreceivedmerge_list(state.params).then((res) => {
        if (res.status == 200) {
          const { count, list } = res.data.data;
          state.tableData = list;
          state.totalCount = count;
        }
      });
    };

    const onLoadCustomer = () => {
      data_customer_select().then((res) => {
        if (res.status == 200) {
          state.customer_data = res.data.data?.list;
        }
      });
    };

    //排序
    const onSortChange = ({ column }) => {
      if (column.order) {
        state.params.sort_field = column.sortable;
        state.params.sort_value = column.order === "ascending" ? "asc" : "desc";
      } else {
        const params = new InitFormData().params;
        state.params.sort_field = params.Order;
        state.params.sort_value = "asc";
      }
      onLoad();
    };

    //重置查询条件
    const onReset = () => {
      delete state.bank_account_ids;
      Object.assign(state, new InitFormData());
      onLoad();
    };

    return {
      state,
      onLoad,
      onSortChange,
      onReset,
      onLoadCustomer,
    };
  },
};
</script>
<style lang="less"></style>
